<template>
  <div class="wrapper">
    <img
      class="image"
      :src="logoutUrl"
      height="1"
      width="1"
      @load="onFinish"
      @error="onFinish"
    />
  </div>
</template>

<script>
const TIMEOUT_SECONDS = 10;

export default {
  name: "auth-logout-request",
  data() {
    return {
      finished: false
    };
  },
  props: {
    url: {
      type: String
    },
    index: {
      type: [String, Number]
    }
  },
  computed: {
    logoutUrl() {
      return this.url + "?accounts=1&q=" + Date.now();
    }
  },
  methods: {
    onFinish() {
      if (this.finished) {
        return;
      }
      this.finished = true;
      this.$emit("finished", this.index);
    }
  },
  mounted() {
    if (this.url) {
      setTimeout(() => {
        this.finished = true;
        this.$emit("finished", this.index);
      }, TIMEOUT_SECONDS * 1000);
    } else {
      this.$emit("finished", this.index);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.wrapper {
  overflow: hidden;
  position: absolute;
  top: -1000px;
}

.image {
  opacity: 0;
}
</style>
